module.exports = __webpack_public_path__ + "static/media/tauchsieder_frage.5805a325.jpg";